"use client";

import AppImage from "@/components/ui/AppImage";
import Icon from "@/components/ui/AppIcon";

const shippingPhotos = [
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_1da6652c3-1772180123051.png",
  alt: "DHL yellow express courier shipping boxes stacked ready for international delivery",
  tag: "DHL Express",
  caption: "DHL 國際快遞",
  captionSub: "全球次日達服務"
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_19d92f06f-1772180124135.png",
  alt: "FedEx purple orange shipping label on cardboard box with tracking barcode",
  tag: "FedEx",
  caption: "FedEx 快遞標籤",
  captionSub: "可追蹤出貨單號"
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_14fdd9683-1772180122443.png",
  alt: "Professional packaging of computer hardware in bubble wrap and foam inside shipping box",
  tag: "專業包裝",
  caption: "防靜電專業包裝",
  captionSub: "氣泡膜+防靜電袋保護"
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_11c79a451-1772142527883.png",
  alt: "Courier delivery person scanning package barcode with handheld scanner at warehouse",
  tag: "出貨掃描",
  caption: "出貨條碼掃描",
  captionSub: "每件貨物追蹤記錄"
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_1e4e210d1-1772180123409.png",
  alt: "Cargo airplane on runway representing international air freight shipping service",
  tag: "空運",
  caption: "國際空運配送",
  captionSub: "香港→全球 2-5工作天"
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_19b9efa89-1772180126318.png",
  alt: "Shipping tracking screen showing package location and delivery status updates",
  tag: "追蹤系統",
  caption: "即時追蹤系統",
  captionSub: "線上查詢出貨狀態"
}];


const shippingOptions = [
{
  courier: "DHL Express",
  icon: "https://img.rocket.new/generatedImages/rocket_gen_img_1c107eb56-1772180120016.png",
  iconAlt: "DHL Express courier logo yellow branding",
  time: "1-3 工作天",
  coverage: "全球220+國家",
  features: ["即時追蹤", "簽收確認", "保險保障"],
  color: "border-yellow-400"
},
{
  courier: "FedEx International",
  icon: "https://img.rocket.new/generatedImages/rocket_gen_img_1ef42c9ea-1772180122579.png",
  iconAlt: "FedEx purple orange delivery van international shipping",
  time: "2-5 工作天",
  coverage: "全球200+國家",
  features: ["門到門服務", "清關協助", "貨物追蹤"],
  color: "border-purple-400"
},
{
  courier: "香港本地速遞",
  icon: "https://img.rocket.new/generatedImages/rocket_gen_img_157551e4e-1772180123697.png",
  iconAlt: "Local Hong Kong delivery motorcycle courier",
  time: "當日 / 次日",
  coverage: "香港全境",
  features: ["當日出貨", "指定時段", "免費送貨*"],
  color: "border-orange"
}];


export default function LogisticsSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-8xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-xl bg-orange/10 flex items-center justify-center">
              <Icon name="TruckIcon" size={20} className="text-orange" />
            </div>
            <span className="text-xs font-black text-orange uppercase tracking-widest">物流配送 · Logistics</span>
          </div>
          <h2 className="font-heading font-black text-3xl md:text-4xl text-navy mb-3">
            快遞出貨 · 全球配送
          </h2>
          <p className="text-text-muted text-base max-w-2xl mx-auto">
            與 DHL、FedEx 等國際快遞合作，提供全球配送服務。所有貨物均以防靜電專業包裝，
            確保產品安全送達。
          </p>
        </div>

        {/* Shipping Photos Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-5 mb-14">
          {shippingPhotos?.map((photo, i) =>
          <div key={i} className="group overflow-hidden rounded-3xl shadow-md border border-navy-100">
              <div className="relative h-52 overflow-hidden">
                <AppImage
                src={photo?.src}
                alt={photo?.alt}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              
                <div className="absolute top-3 left-3">
                  <span className="bg-navy text-white text-xs font-bold px-3 py-1 rounded-full">
                    {photo?.tag}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-navy/60 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <div className="text-white font-bold text-sm">{photo?.caption}</div>
                  <div className="text-white/70 text-xs">{photo?.captionSub}</div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Shipping Options */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {shippingOptions?.map((option) =>
          <div key={option?.courier} className={`bg-navy-50 border-2 ${option?.color} rounded-3xl p-6`}>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-xl overflow-hidden border border-navy-100">
                  <AppImage
                  src={option?.icon}
                  alt={option?.iconAlt}
                  className="w-full h-full object-cover" />
                
                </div>
                <div>
                  <div className="font-bold text-navy text-base">{option?.courier}</div>
                  <div className="text-xs text-text-muted">{option?.coverage}</div>
                </div>
              </div>
              <div className="flex items-center gap-2 mb-4">
                <Icon name="ClockIcon" size={16} className="text-orange" />
                <span className="text-orange font-bold text-sm">{option?.time}</span>
              </div>
              <ul className="space-y-2">
                {option?.features?.map((feat) =>
              <li key={feat} className="flex items-center gap-2 text-sm text-text-mid">
                    <Icon name="CheckCircleIcon" size={14} className="text-green-500" />
                    {feat}
                  </li>
              )}
              </ul>
            </div>
          )}
        </div>

        {/* CTA */}
        <div className="bg-navy rounded-3xl p-8 md:p-12 text-center">
          <h3 className="font-heading font-black text-2xl md:text-3xl text-white mb-3">
            準備好下單了嗎？
          </h3>
          <p className="text-white/70 mb-6 max-w-xl mx-auto">
            聯絡我們獲取報價，我們將在24小時內回覆並安排出貨。
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="https://wa.me/85259773386"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-orange hover:bg-orange-dark text-white px-6 py-3 rounded-full font-bold text-sm transition-all">
              
              <Icon name="ChatBubbleLeftRightIcon" size={16} variant="solid" />
              WhatsApp 立即詢問
            </a>
            <a
              href="/contact"
              className="flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white border border-white/30 px-6 py-3 rounded-full font-bold text-sm transition-all">
              
              <Icon name="EnvelopeIcon" size={16} />
              發送詢價表單
            </a>
          </div>
        </div>
      </div>
    </section>);

}